import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const PlayCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M2.929 2.929A10 10 0 1 1 17.07 17.07 10 10 0 0 1 2.93 2.93Zm4.154 3.445v7.252c0 .851 1.109 1.277 1.757.676l4.608-3.627a.906.906 0 0 0 0-1.35L8.84 5.698c-.648-.602-1.757-.174-1.757.676" }), _jsx("path", { d: "M7.083 13.628V6.374c0-.85 1.109-1.278 1.757-.676l4.608 3.627a.906.906 0 0 1 0 1.35L8.84 14.302c-.648.601-1.757.175-1.757-.676z", fill: innerFillValue })] }));
});
PlayCircled.displayName = 'PlayCircled';
PlayCircled.__iconComponentType = 'contrast';
export default PlayCircled;
//# sourceMappingURL=PlayCircled.js.map